import { z } from "zod";

export const complaintSchema = z.object({
  lastName: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),

  firstName: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  city: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  phone: z.string().optional().or(z.literal("")),

  subject: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  company: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  message: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  email: z
    .string({ required_error: "Ce champ est obligatoire" })
    .email({ message: "Veuillez renseigner un mail valide" }),
  terms: z
    .boolean({ required_error: "Vous devez accepter les termes et conditions" })
    .refine((val) => val === true, {
      message: "Vous devez accepter les termes et conditions",
    }),
});

export type ProjectComplaintValues = z.infer<typeof complaintSchema>;

export const updateComplaintSchema = z
  .object({
    lastName: z.string().min(1, { message: "Ce champ est obligatoire" }),
    firstName: z.string().min(1, { message: "Ce champ est obligatoire" }),
    receiver: z.string().min(1, { message: "Sélectionner un rôle" }),
    subject: z.string().min(1, { message: "Ce champ est obligatoire" }),
    company: z.string().min(1, { message: "Ce champ est obligatoire" }),
    message: z.string().min(1, { message: "Ce champ est obligatoire" }),
    email: z.string().email({ message: "Ce champ est obligatoire" }),
  })
  .partial();

export type UpdateComplaintFormValues = z.infer<typeof updateComplaintSchema>;
